export enum SubmitActionTypes {
	confirm,
	cancel,
}
